/**
 *  接口用法: 
            this.$api.signin(params).then(res => {
              if(res.rescode == 0){
             
              }else{that.$Message.error(res.msg);}
            }).catch(err => {});
 */

import axios from './http'
import qs from 'qs'

export default {
  // 登录
  signin(params){
    return axios.post(`${process.env.API_HOST}/user/login.php`, qs.stringify(params))
  },
  // 获取banner图片
  getBannerList(params){
    return axios.post(`${process.env.API_HOST}/banner/listall.php`, qs.stringify(params))
  },
  // 读取版权信息
  getCopyrightInfo(params){
    return axios.post(`${process.env.API_HOST}/basic/copyright.php`, qs.stringify(params))
  },
  // 读取aboutus信息 
  getAboutInfo(params){
    return axios.post(`${process.env.API_HOST}/basic/aboutus.php`, qs.stringify(params))
  },
  // 读取contact 信息 
  getContactInfo(params){
    return axios.post(`${process.env.API_HOST}/basic/contact.php`, qs.stringify(params))
  },

  // 获取相册列表  [ galleryTypeId -> 过滤]
  getAlbumList(params){
    return axios.post(`${process.env.API_HOST}/gallery/list.php`, qs.stringify(params))
  },
  // 相册下的图片列表 
  getPicListAll(params){  // [galleryId]
    return axios.post(`${process.env.API_HOST}/photo/listall.php`, qs.stringify(params))
  },
  // 发送留言
  sendMessage(params){
    return axios.post(`${process.env.API_HOST}/msg/submit.php`, qs.stringify(params))
  },
  // team详情
  getTeamDetail(params){
    return axios.post(`${process.env.API_HOST}/basic/team.php`, qs.stringify(params))
  },
  // workflow详情
  getWorkflowDetail(params){
    return axios.post(`${process.env.API_HOST}/basic/workflow.php`, qs.stringify(params))
  },
  // news list
  getNewsList(params){
    return axios.post(`${process.env.API_HOST}/news/list.php`, qs.stringify(params))
  },
  // news detail
  getNewsDetail(params){
    return axios.post(`${process.env.API_HOST}/news/detail.php`, qs.stringify(params))
  },
}


// WEBPACK FOOTER //
// ./src/common/api.config.js